// Helpful? under the platform agent's finished answers and cards (D10). Wording from the Amigo design's copy sheet
// (Helpful?).
export default {
  question: 'Útil?',
  helpful: 'Útil',
  not_helpful: 'Não útil',
  thanks: 'Obrigado, registado.',
};
